import { useCallback, useEffect, useState } from "react";
import { isLocalDashboard } from "../OrgUsageAnalytics/api";

const STORAGE_KEY = "referral-eligibility-env";

const isValid = (value) => value === "prod" || value === "dev";

const getDefaultEnv = () => (isLocalDashboard() ? "dev" : "prod");

/**
 * Environment toggle for Referral Eligibility. Defaults to Dev on localhost so
 * local dashboard development hits the local/emulator backend instead of prod.
 */
export function useReferralEligibilityEnv() {
  const [env, setEnvState] = useState(() => {
    if (typeof window === "undefined") {
      return getDefaultEnv();
    }

    try {
      const stored = window.localStorage.getItem(STORAGE_KEY);
      if (isValid(stored)) {
        return stored;
      }
    } catch {
      // ignore
    }

    return getDefaultEnv();
  });

  useEffect(() => {
    if (typeof window === "undefined") {
      return undefined;
    }

    const onStorage = (event) => {
      if (event.key === STORAGE_KEY && isValid(event.newValue)) {
        setEnvState(event.newValue);
      }
    };

    window.addEventListener("storage", onStorage);

    return () => window.removeEventListener("storage", onStorage);
  }, []);

  const setEnv = useCallback((next) => {
    if (!isValid(next)) {
      return;
    }

    setEnvState(next);
    try {
      window.localStorage.setItem(STORAGE_KEY, next);
    } catch {
      // ignore quota / private-mode errors
    }
  }, []);

  return [env, setEnv];
}
